<template>
  <v-row>
    <v-col class="pt-0" cols="4">
      <v-card class="grey lighten-4">
        <v-card-title class="text-uppercase">
          Storage {{ storage.name }}
          <v-spacer />
          <container-form :key="storage.name" :storage="storage.name">
            <v-btn color="primary" dark>
              Add Container
            </v-btn>
          </container-form>
        </v-card-title>
        <v-card-subtitle>
          {{ storage.azureName }}
          {{ storage.connectionStringConfigKey }}
        </v-card-subtitle>
        <v-card-text>
          <container-card
            @selected="selectedContainer"
            v-for="container in containers"
            :key="container.name"
            :container="container"
            :storage="storage.name"
            :isSelected="isSelected(container.name)"
          ></container-card>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col class="pt-0" v-if="hasContainerSelected">
      <client-list
        :clients="currentClients"
        :storage="storage"
        :container="currentContainer"
      ></client-list>
    </v-col>
  </v-row>
</template>

<script>
import ContainerForm from './ContainerForm.vue'
import ClientList from './ClientList.vue'
import ContainerCard from './ContainerCard.vue'
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapActions } = createNamespacedHelpers('storage')
export default {
  components: { ContainerCard, ContainerForm, ClientList },
  name: 'ContainerList',
  props: {
    containers: {
      type: Array,
      required: true
    },
    storage: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      // currentContainer: null
    }
  },
  computed: {
    ...mapState(['currentContainer']),
    hasContainerSelected() {
      return this.currentContainer ? true : false
    },
    currentClients() {
      if (
        this.currentContainer &&
        Array.isArray(this.currentContainer.clients)
      ) {
        return this.currentContainer.clients
      } else {
        return []
      }
    }
  },
  methods: {
    ...mapActions(['setCurrentContainer']),
    selectedContainer(container) {
      this.setCurrentContainer(container)
      // this.currentContainer = container
    },
    isSelected(name) {
      return this.currentContainer && this.currentContainer.name === name
        ? true
        : false
    }
  }
}
</script>

<style></style>
